import styled, { css } from 'styled-components';

export const Text = styled.section`
  padding-bottom: 80px;
  padding-top: 80px;
`;

export const Container = styled.div`
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 800px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 48px;
        }
        @media (max-width: ${theme.breakpoints.small}) {
          padding: 0 24px;
        }
        @media (max-width: ${theme.breakpoints.extraSmall}) {
          padding: 0 16px;
        }
      `
    );
  }}
  > img {
    display: block;
    height: auto;
    margin: 30px auto;
    max-width: 600px;
    width: 100%;
  }
  p {
    margin-bottom: 20px;
    &.s {
      margin-left: 15px;
    }
  }
  ol {
    li {
      list-style-position: inside;
      margin-bottom: 10px;
      margin-left: 15px;
    }
  }
  > h2 {
    font: bold 30px/40px 'Montserrat', sans-serif;
    letter-spacing: 0.5px;
    margin-bottom: 30px;
    text-align: center;
    i {
      display: block;
      font: 14px/24px 'Montserrat', sans-serif;
      text-align: center;
    }
  }
  > h3 {
    font: normal 18px/28px 'Montserrat', sans-serif;
    letter-spacing: 0.5px;
    margin-bottom: 30px;
    margin-top: 40px;
  }
  > h4 {
    font: normal 16px/26px 'Montserrat', sans-serif;
    letter-spacing: 0.5px;
    margin-bottom: 20px;
    margin-top: 30px;
  }

  table {
    margin-bottom: 20px;
    margin-top: 20px;
    width: 100%;
    th,
    td {
      border: 1px solid;
      font-size: 14px;
      padding: 5px 2.5px;
      text-align: center;
    }
    th {
      font-weight: bold;
      &:nth-child(2) {
        width: 40%;
      }
    }
  }
`;
